import { ActionType } from "../../model/actionTypes";

export const resetOdPassword = (data: any) => async (dispatch: Function, getState: Function, api: any) => {
    dispatch({ type: ActionType.LOADER, payload: true });
    try {
        const resp = await api.post("users/resetOdPassword", data, null);
        dispatch({ type: ActionType.LOADER, payload: false });
        return resp;
    } catch (err) {
        dispatch({ type: ActionType.LOADER, payload: false });
        dispatch({ type: ActionType.ALERT, payload: err });
        return null;
    }
};

export const getOdUsersInPractices = (practiceIds: number[]) => async (dispatch: Function, getState: Function, api: any) => {
    try {
        const resp = await api.get("users/odUsersInPractices", null, { practiceIds: JSON.stringify(practiceIds) });
        return resp;
    } catch (err) {
        return [];
    }
};
